module.exports = __webpack_public_path__ + "img/5.e4e206b5.svg";